<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="800px"
    title="新增"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    top="5vh"
    append-to-body
  >
    <div class="content">
      <el-form
        ref="formRef"
        :model="form"
        label-width="auto"
        :rules="rules"
        style="max-width: 800px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="MARK" prop="mark">
              <el-input v-model="form.mark" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="英文品名" prop="nameEN">
              <el-input v-model="form.nameEN" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="中文品名" prop="nameCH">
              <el-input v-model="form.nameCH" disabled>
                <template slot="append">
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-search"
                    @click="dialogVisible1 = true"
                  ></i>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="HSCODE" prop="hsCode">
              <el-input v-model="form.hsCode" disabled>
                <template slot="append">
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-search"
                    @click="dialogVisible2 = true"
                  ></i>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="产品材质" prop="material">
              <el-input v-model="form.material" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品用途" prop="usedFor">
              <el-input v-model="form.usedFor" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="箱数" prop="packages">
              <el-input-number
                v-model="form.packages"
                style="width: 100%"
                :min="1"
                controls-position="right"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品个数" prop="qty">
              <el-input-number
                v-model="form.qty"
                :min="1"
                style="width: 100%"
                controls-position="right"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="产品单价" prop="unitPrice">
              <el-input-number
                v-model="form.unitPrice"
                style="width: 100%"
                :min="0.01"
                :precision="2"
                controls-position="right"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品净重" prop="netWeight">
              <el-input-number
                v-model="form.netWeight"
                :min="0.01"
                :precision="2"
                style="width: 100%"
                controls-position="right"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="产品毛重" prop="grossWeight">
              <el-input-number
                v-model="form.grossWeight"
                style="width: 100%"
                :min="0.01"
                :precision="2"
                controls-position="right"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template slot="footer">
      <div class="footer">
        <div class="cancel" @click="cancel">取消</div>
        <div class="ok" @click="ok">确认</div>
      </div>
    </template>
    <ProductDialog
      :dialogVisible="dialogVisible1"
      @ok="productOk"
      @cancel="dialogVisible1 = false"
    >
    </ProductDialog>
    <TaxDialog
      :dialogVisible="dialogVisible2"
      @ok="taxOk"
      @cancel="dialogVisible2 = false"
    >
    </TaxDialog>
  </el-dialog>
</template>

<script>
import ProductDialog from '../dialog/ProductDialog.vue'
import TaxDialog from '../dialog/TaxDialog.vue'
export default {
  components: { ProductDialog, TaxDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    mblType: {
      type: Number,
      default: 0
    }
  },
  data() {
    const validateHsCode = (rule, value, callback) => {
      if (value.length !== 10) {
        return callback(new Error('税号格式不正确'))
      } else {
        callback()
      }
    }
    return {
      form: {
        mark: '',
        nameEN: '',
        nameCH: '',
        hsCode: '',
        material: '',
        usedFor: '',
        packages: '',
        qty: '',
        unitPrice: '',
        netWeight: '',
        grossWeight: ''
      },
      rules: {
        hsCode: [
          { required: true, message: '请输入10位税号', trigger: 'change' },
          { required: true, trigger: 'change', validator: validateHsCode }
        ],
        nameEN: [
          { required: true, message: '请输入英文品名', trigger: 'blur' }
        ],
        nameCH: [
          { required: true, message: '请输入中文品名', trigger: 'blur' }
        ],
        material: [{ required: true, message: '请输入材质', trigger: 'blur' }],
        usedFor: [{ required: true, message: '请输入用途', trigger: 'blur' }],
        packages: [{ required: true, message: '请输入箱数', trigger: 'blur' }],
        qty: [{ required: true, message: '请输入个数', trigger: 'blur' }],
        unitPrice: [
          { required: true, message: '请输入产品单价', trigger: 'blur' }
        ],
        netWeight: [
          { required: true, message: '请输入产品净重', trigger: 'blur' }
        ],
        grossWeight: [
          { required: true, message: '请输入产品毛重', trigger: 'blur' }
        ]
      },
      dialogVisible1: false,
      dialogVisible2: false,
      dialogFormVisible: false
    }
  },
  watch: {
    dialogVisible: {
      handler: function(newValue, oldValue) {
        this.formRef.value?.resetFields()
      }
    }
  },
  created() {},
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    ok() {
      this.$refs.formRef.validate(async(valid) => {
        if (valid) {
          if (this.form.netWeight >= this.form.grossWeight) {
            return this.$message.error('请注意产品净重要小于产品毛重')
          }
          this.$emit('ok', this.form)
        }
      })
    },
    productOk(item) {
      this.form = { ...this.form, ...item }
      this.form.usedFor = item.used
      this.dialogVisible1 = false
    },
    taxOk(item) {
      this.form = { ...this.form, ...item }
      this.dialogVisible2 = false
    }
  }
}
</script>

<style scoped>
.content {
  width: 100%;

  &:deep(.el-input-group__append) {
    background: #ffffff;
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 5px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    text-align: center;
    align-content: center;
    font-weight: 400;
    font-size: 12px;
    color: #cdcdcd;
  }
}

.footer {
  width: 100%;
  display: flex;
  justify-content: center !important;

  & > div {
    width: 120px;
    height: 40px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    align-content: center;
    cursor: pointer;
    border-radius: 4px;
    box-sizing: border-box;

    & + div {
      margin-left: 20px;
    }
  }

  .ok {
    color: #ffffff;
    background: #142e79;
  }

  .cancel {
    border: 1px solid #dcdfe6;
  }
}
</style>
